import React, { useState } from "react";
import { Alert } from "reactstrap";

import { TurmaResponse } from "../../../api/turmas";
import { Titulo } from "../../Titulo";
import { RelatoriosAbas } from "../RelatorioAbas";
import { Filtros } from "./Filtros";
import { TabelaNotas } from "./TabelaNotas";

export function RelatoriosNotasDaTurmaPage() {
  const [error, setError] = useState<string>();
  const [turma, setTurma] = useState<TurmaResponse>();

  const onFilter = (turma: TurmaResponse) => {
    setError(undefined);
    setTurma(turma);
  };

  const onError = (e?: string) => {
    setError(e);
    if (e) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <div>
      <RelatoriosAbas />
      <Titulo text="Notas da Turma" />
      {error && (
        <Alert color="danger" data-cy="alert">
          {error}
        </Alert>
      )}
      <Filtros onFilter={onFilter} onError={onError} />
      <div className="w-100 table-responsive">
        <TabelaNotas turma={turma} onError={onError} />
      </div>
    </div>
  );
}
